import * as React from "react";
import { Box, Grid } from "@material-ui/core";

import TextInputRA from "../components/TextInputRA";
import HiddenInputRA from "../components/HiddenInputRA";
import GeneralSelect from "../components/GeneralSelect";
import LeftGridCreate from "../components/LeftGridCreate";
import RightGridCreate from "../components/RightGridCreate";
import LayoutContainer from "../components/LayoutContainer";
import OfferValidation from "../../../ValidationRules/OfferValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
const transform = (data) => ({
  ...data,
  items: [{ value: data.coupon_value, coupon_id: data.coupon_id }],
  conditions: [
    {
      value: data.condition_value,
      condition_id: data.offer_condition_id,
    },
  ],
});

const SpecialOfferCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate
        {...props}
        transform={transform}
        validate={OfferValidation}
      >
        <SfBreadcrumbs path="Management/Discount and Special Offers/New" />
        <Box style={{ margin: 50 }}>
          <TextInputRA required label="Name" source="name" />
          <TextInputRA label="Description" source="desc" />

          <GeneralSelect
            require
            label="Condition"
            resource="conditions"
            source={"offer_condition_id"}
          />
          <TextInputRA
            required
            label="Condition Value"
            source="condition_value"
            type="number"
          />

          <GeneralSelect
            require
            label="Benefit"
            resource="coupons"
            source={"coupon_id"}
          />

          <TextInputRA
            required
            label="Benefit Value"
            source="coupon_value"
            type="number"
          />
          <TextInputRA label="Authorize PIN" source="authorize_pin" />
          <HiddenInputRA source="status" initialValue="Active" />
        </Box>
      </LeftGridCreate>
      <RightGridCreate />
    </Grid>
    {/* <Create {...props} title="Create Special offers" transform={transform}>
      <SimpleForm redirect="list">
        <TextInputRA label="Name" source="name" />
        <TextInputRA label="Description" source="desc" />
        <ReferenceArrayInput
          label="Condition"
          source="offer_condition_id"
          reference="conditions"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <TextInputRA label="Value" source="condition_value" type="number" />
        <ReferenceArrayInput
          label="Coupon"
          source="coupon_id"
          reference="coupons"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <TextInputRA label="Value" source="coupon_value" type="number" />
        <TextInputRA label="Authorize PIN" source="authorize_pin" />
        <HiddenInputRA source="status" initialValue="Active" />
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.Offer" write />
  </LayoutContainer>
);

export default SpecialOfferCreate;
